
import React from 'react';

const AssociationSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-[#2A6041] mb-4">農業ドローン協議会について</h2>
          <p className="text-xl sm:text-lg text-gray-600">DJI農業ドローンの技能認定を行う業界団体</p>
        </div>

        <div className="bg-gray-50 rounded-2xl p-8 lg:p-12">
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              農業ドローン協議会は、DJI農業ドローンの安全で適正な運用を推進する業界団体です。
              農薬散布における安全性と効率性を両立するため、操縦者の技能認定制度を運営しています。
            </p>

            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-2xl font-bold text-[#2A6041] mb-4">協議会の役割</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>技能認定制度の運営</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>安全運用ガイドラインの策定</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>教習所の認定・監督</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>業界標準の確立</span>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-[#2A6041] mb-4">認定の意義</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>業界統一の技能基準</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>安全性の向上</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>社会的信頼の獲得</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-check-line text-[#76B947] mr-3 mt-1 flex-shrink-0"></i>
                    <span>継続的な技術向上</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssociationSection;
